import brandConfig from 'brandConfig'
import { toLower } from './string.helpers'
import { isArray } from './object.helpers'

export const LANGUAGE_EN = 'en'
export const LANGUAGE_IT = 'it'
export const LANGUAGE_DE = 'de'
export const LANGUAGE_FR = 'fr'
export const LANGUAGE_NL = 'nl'
export const LANGUAGE_ES = 'es'
export const LANGUAGE_HU = 'hu'

export const LANGUAGE_LABELS = {
  [LANGUAGE_EN]: 'English',
  [LANGUAGE_IT]: 'Italiano',
  [LANGUAGE_DE]: 'Deutsch',
  [LANGUAGE_FR]: 'Français',
  [LANGUAGE_NL]: 'Nederlands',
  [LANGUAGE_ES]: 'Español',
  [LANGUAGE_HU]: 'Magyar'
}

const getLanguageLabelsByPref = (languages) => {
  if (languages && languages.length > 0) {
    const filteredLanguages = {}
    languages.forEach((language) => {
      filteredLanguages[language] = LANGUAGE_LABELS[language]
    })
    return filteredLanguages
  }
  return LANGUAGE_LABELS
}

const getSupportedLanguages = () => {
  return brandConfig.supportedLanguages
}

const isMultiLanguage = () => {
  return getSupportedLanguages().length > 1
}

const checkTriggeredByLabel = (triggeredBy, label) => {
  if (!triggeredBy) {
    return false
  }
  return isArray(label)
    ? label.find((item) => toLower(triggeredBy).includes(item))
    : toLower(triggeredBy).includes(label)
}

const isValidCashbackBonus = (label) => /^cashback .+? - .+$/i.test(label)

export {
  checkTriggeredByLabel,
  getLanguageLabelsByPref,
  getSupportedLanguages,
  isMultiLanguage,
  isValidCashbackBonus
}
